export default __webpack_public_path__ + "static/besiktas-logo-fc589e7687b7d72ace68f8f596df36bf.png";